import { useIntl } from 'react-intl'
import Image from 'components/Common/Image/Image'

const SIZE_MAP = {
  width: 348,
  aspectRatio: '2:1',
}

function WineSelectorsLogo() {
  const intl = useIntl()
  return (
    <Image
      image={{ id: 'wine-selectors-logo' }}
      width={SIZE_MAP.width}
      aspectRatio={SIZE_MAP.aspectRatio}
      gravity="center"
      alt={intl.formatMessage({
        id: 'oHQFuhcDaXgY1UIw7f-9',
        defaultMessage: 'Wine Selectors logo',
        description: 'Alt text for the Wine Selectors partner promotion logo image',
      })}
    />
  )
}

export default WineSelectorsLogo
